/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import AggregataSelector from '../../common/AggregataSelector';
import BetSelector from '../../common/BetSelector';
import ExpandedViewToggle from '../../common/ExpandedViewToggle';
import FastbetToggle from '../../common/fast-bet/FastbetToggle';
import Loader from '../../common/Loader';
import MacrogruppoSelector from '../../common/MacrogruppoSelector';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { useFetchTournamentsByDate } from '../../data/fetchTournamentsByDate';
import { classIf } from '../../data/utils/classIf';
import { filtraParametriche } from '../../data/utils/filtraParametriche';
import { getConfiguration } from '../../data/utils/configuration';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils/getPrincipaleOPrimoMacroGruppo';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import { betsExpanded } from '../tournament/TournamentDataFetcher';
import Match from './Match';

function getFirstMatch(data) {
    let match = null;
    try {
        const tournaments = data.tournamentsByTime.get(data.times[0]);
        match = tournaments[0].matches[0];
    } catch (e) {
        console.error(e);
    }
    return match;
}

function getTimesBySortType(times, sortType) {
    if (sortType === 'asc') {
        return times.sort();
    } else {
        return times.sort().reverse();
    }
}

function EventsByDate(props) {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const sport = prematchContext.temporalFilter.sport;
    const [state, setState] = useState({
        data: null,
        date: prematchContext.temporalFilter.date,
        sportFetch: sport,
        sport,
        macrogruppo: null,
        aggregata: null,
        bet: null,
        aggregataFetch: sport.aggregata,
        match: null,
        expanded: betsExpanded(),
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setExpanded() {
            this.update({expanded: !this.expanded});
            localStorage.setItem('xs_bets_expanded', !this.expanded);
        },
        setData(data) {
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo == null) {
                macrogruppo = data.macrogruppi.find(mg => mg.id === this.sportFetch.macrogruppo) || getPrincipaleOPrimoMacroGruppo(data.macrogruppi);
            }
            let firstMatch = this.match;
            if (firstMatch == null) {
                const tournaments = data.tournamentsByTime.get(data.times[0]);
                firstMatch = tournaments[0].matches[0];
                const mg = data.macrogruppi.find(mg => mg.id === firstMatch.openMacrogruppo);
                if (mg && this.macrogruppo && mg.id !== this.macrogruppo.id) {
                    macrogruppo = mg;
                }
            }
            const bet = macrogruppo.aggregate.find(ag => ag.idAggregata === this.aggregataFetch).scommesse[0];
            this.update({data, sport: this.sportFetch, macrogruppo, aggregata: this.aggregataFetch, bet, match: firstMatch});
        },
        changeDate(filter) {
            const sport = filter.sport;
            this.update({date: filter.date, sportFetch: sport, macrogruppoFetch: null, aggregataFetch: sport.aggregata, match: null});
        },
        changeSport(sportId) {
            const sportFetch = this.data.sportById.get(sportId);
            this.update({sportFetch, macrogruppoFetch: null, aggregataFetch: sportFetch.aggregata});
        },
        changeMacrogruppo(macrogruppo) {
            if (macrogruppo !== this.macrogruppo.id) {
                macrogruppo = this.data.macrogruppi.find(mg => mg.id === macrogruppo);
                this.update({macrogruppoFetch: macrogruppo, aggregataFetch: macrogruppo.aggregate[0].idAggregata});
            }
        },
        changeAggregata(aggregata) {
            if (this.aggregata !== aggregata) {
                this.update({aggregataFetch: aggregata});
            }
        },
        changeBet(bet) {
            this.update({bet})
        },
        changeMatch(match) {
            this.update({match});
        }
    });
    const [showSportsMenu, setShowSportsMenu] = useState(false);
    const [showSortMenu, setShowSortMenu] = useState(false);
    const [sortType, setSortType] = useState('league');

    const [request] = useFetchTournamentsByDate(state.date, state.sportFetch.id, state.aggregataFetch);
    const [showLoader, setShowLoader] = useState(true);
    useEffect(function() {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function() {
                setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            setShowLoader(false);
            if (!request.isError) {
                state.setData(request.data);
            }
        }

        return () => {
            clearInterval(timeout);
        };
    }, [request]);

    useEffect(() => {
        if (state.data != null) {
            state.changeDate(prematchContext.temporalFilter);
        }
    }, [prematchContext.temporalFilter]);

    if (showLoader) {
        return <Loader error={request.isError} />;
    }

    const firstMatch = getFirstMatch(state.data);
    let bets = [];
    if (firstMatch != null) {
        bets = firstMatch.bets.filter(bet => bet.hasOdds);
        bets = filtraParametriche(bets);
    }
    let groupedView = false;
    if (GROUPED_VIEW_MARKETS.includes(bets[0].cs)) {
        groupedView = true;
    }
    const showFastbetToggle = conf.anbe;
    const showExpandedViewToggle = !groupedView && bets.length > 1;

    return (
        <>
            <nav className="small">
                <div id="gruppo-scommessa-selector" className="bet-type-selector expandable nav-section-title" onClick={() => setShowSortMenu(!showSortMenu)}>
                    <div className="text-small uppercase push-left"><i className="fa fa-sort-alpha-down"></i> {labels['live.navbar.sort_button.title']}</div>
                    {showSortMenu &&
                        <div id="popup-calendar-sports" className="popup extended">
                            <div className="popup-content">
                                <div className={"event-desc text-small" + classIf(sortType === 'league', 'selected')} onClick={() => setSortType('league')}>
                                    <i className="fa fa-sort-alpha-down"></i>
                                    <span>{labels['live.navbar.sort_popup.sort_by_tournament']}</span>
                                </div>
                                <div className={"event-desc text-small" + classIf(sortType === 'asc', 'selected')} onClick={() => setSortType('asc')}>
                                    <i className="fa fa-sort-up"></i>
                                    <span>{labels['live.navbar.sort_button.sort_by_chronological_order']}</span>
                                </div>
                                <div className={"event-desc text-small" + classIf(sortType === 'desc', 'selected')} onClick={() => setSortType('desc')}>
                                    <i className="fa fa-sort-down"></i>
                                    <span>{labels['live.navbar.sort_button.sort_by_reverse_chronological_order']}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div id="gruppo-scommessa-selector" className="bet-type-selector expandable nav-section-title" onClick={() => setShowSportsMenu(!showSportsMenu)}>
                    <div className="text-small uppercase push-left">{state.sport.descrizione}</div>
                    {showSportsMenu &&
                        <div id="popup-calendar-sports" className="popup">
                            <div className="popup-content">
                                {state.data.sport.map(sport => {
                                    function handleClick() {
                                        state.changeSport(sport.id);
                                    }
                                    return <div key={sport.id} className={"event-desc text-small" + classIf(state.sport.id === sport.id, 'selected')} onClick={handleClick}>{sport.descrizione}</div>
                                })}
                            </div>
                        </div>
                    }
                </div>
            </nav>
            {state.data.macrogruppi.length > 1 &&
                <MacrogruppoSelector macrogruppi={state.data.macrogruppi} macrogruppo={state.macrogruppo.id} changeMacrogruppo={state.changeMacrogruppo.bind(state)} />
            }
            {state.macrogruppo.aggregate.length > 1 &&
                <AggregataSelector betGroups={state.macrogruppo.aggregate} aggregata={state.aggregata} changeBetGroup={state.changeAggregata.bind(state)} />
            }
            {!state.expanded && bets.length > 1 && 
                <BetSelector bets={bets} bet={state.bet} changeBet={state.changeBet.bind(state)} />
            }
            {(showFastbetToggle || showExpandedViewToggle) &&
                <nav id="nav-vista-estesa" className="small">
                    {showFastbetToggle &&
                        <FastbetToggle />
                    }
                    {showExpandedViewToggle &&
                        <div className="d-flex push-right">
                            <label className="custom-switch-2 mr-2">
                                <input type="checkbox" checked={state.expanded === true} onChange={state.setExpanded.bind(state)} />
                                <span className="custom-slider-2 round"></span>
                            </label>
                            <span>{labels['general.expanded_view']}</span>
                        </div>
                    }
                    {groupedView &&
                        <ExpandedViewToggle />
                    }
                </nav>
            }
            {sortType === 'league' ?
                <div id="avvenimenti">
                    {state.data.tournaments.map(t => {
                        const icon = iconCategoryCssClass(t.sportRef, t.categoryRef, t.iconClass);
                        const uniqueId = `${t.sportRef}_${t.categoryRef}_${t.id}`;
                        const sport = props.data?.sportById?.[t.sportRef];
                        const country = sport?.categoryById?.[t.categoryRef];
                        const desc = country ? `${country.descrizione} - ${t.desc}` : t.desc;
                        return (
                            <React.Fragment key={t.id}>
                                <div className="heading" onClick={() => prematchContext.openTournamentFromEventsByDate(uniqueId)}>
                                    <span className={`border img-fluid ico-cat iconCategoryLive ${icon}`}></span>
                                    <span className="text-medium">{desc}</span>
                                    <span className="arrow arrow-right push-left"></span>
                                </div>
                                {t.matches.map(match => {
                                    return <Match key={match.uniqueId} data={props.data} match={match} aggregata={state.aggregata} bet={state.bet} expanded={state.expanded} />
                                })}
                            </React.Fragment>
                        );
                    })}
                </div>
                :
                <div id="avvenimenti">
                    {getTimesBySortType(state.data.times, sortType).map(time => {
                        return state.data.tournamentsByTime.get(time).map(t => {
                            const icon = iconCategoryCssClass(t.sportRef, t.categoryRef, t.iconClass);
                            const uniqueId = `${t.sportRef}_${t.categoryRef}_${t.id}`;
                            const sport = props.data?.sportById?.[t.sportRef];
                            const country = sport?.categoryById?.[t.categoryRef];
                            const desc = country ? `${country.descrizione} - ${t.desc}` : t.desc;
                            return (
                                <React.Fragment key={t.id}>
                                    <div className="heading" onClick={() => prematchContext.openTournamentFromEventsByDate(uniqueId)}>
                                        <span className={`border img-fluid ico-cat iconCategoryLive ${icon}`}></span>
                                        <span className="text-medium">{desc}</span>
                                        <span className="arrow arrow-right push-left"></span>
                                    </div>
                                    {t.matches.map(match => {
                                        return <Match key={match.uniqueId} data={props.data} match={match} aggregata={state.aggregata} bet={state.bet} expanded={state.expanded} />
                                    })}
                                </React.Fragment>
                            )
                        })
                    })}
                </div>
            }
        </>
    );
}

export default EventsByDate;